export default __webpack_public_path__ + "static/media/compas_data.239e2467.csv";